// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__Cz2L1","footer":"ReportModalFilter_footer__8h-Lz"};